import request from '../utils/request';
const querystring = require('querystring')

//获取系统登录信息 
export const getStationByLogin = query => {
    var list = request({
        url: 'common/getStationByLogin.do',
        method: 'post',
        data: querystring.stringify(query),
    }); 
    return list;
};
export const getImgCode = query => {  
    var list = request({
        url: 'common/getImgCode.do',
        method: 'post',
        params: query, 
        
    }); 
    return list;
};
export const getContent = query => {
    var list = request({
        url: 'common/getContent.do',
        method: 'post',
        data:  querystring.stringify(query),
    });
    return list;
};
//注册代理信息
export const sendSmsCode = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    query.fid = localStorage.getItem('ms_fid'); 
    var list = request({
        url: 'haoka/common/sendSmsCode.do',
        method: 'post',
        params: query,  
    }); 
    return list;
};
//sendNextCode
export const sendNextCode = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    query.fid = localStorage.getItem('ms_fid'); 
    var list = request({
        url: 'haoka/common/sendNextCode.do',
        method: 'post',
        params: query, 
        
    }); 
    return list;
}; 
export const createSmsCode = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    query.fid = localStorage.getItem('ms_fid'); 
    var list = request({
        url: 'haoka/common/createSmsCode.do',
        method: 'post',
        params: query, 
        
    }); 
    return list;
};

export const sendSecondCode = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    query.fid = localStorage.getItem('ms_fid'); 
    var list = request({
        url: 'haoka/common/sendSecondCode.do',
        method: 'post',
        params: query, 
        
    }); 
    return list;
};
//getStation
export const getStation = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/openapi/getStation.do',
        method: 'post',
        params: query, 
        
    }); 
    return list;
};





 


